import { MyLearningContainer } from 'modules/MyLearning'
import React from 'react'

type Props = {}

const MyLearning = (props: Props) => {
  return (
    <MyLearningContainer />
  )
}

export default MyLearning